<section class="testimonials-section">
  <div class="container">
    <div class="section-header">
      <p class="section-title">Nur wenn du wirklich 100% gibst</p>
      <h2 class="section-subtitle">Sei Teil der Community,<br>schau dir an, was möglich ist!</h2>
    </div>
    
    <div class="testimonials-grid">
      <div class="testimonial-card" *ngFor="let testimonial of testimonials">
        <div class="video-thumbnail" (click)="openVideo(testimonial, $event)">
          <img [src]="testimonial.thumbnail" [alt]="testimonial.name + ' video thumbnail'" class="thumbnail-img">
          <div class="play-button">
            <mat-icon>play_arrow</mat-icon>
          </div>
        </div>
        
        <div class="testimonial-content">
          <div class="rating-container">
            <div class="stars">
              <img  src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2a677130668674f6e2b6d_trust-bubble.svg" alt="star">
            </div>
          </div>
          
          <div class="profile">
            <img [src]="testimonial.profileImage" [alt]="testimonial.name" class="profile-image">
            <h3 class="profile-name">{{ testimonial.name }}</h3>
          </div>
          
          <p class="testimonial-text">{{ testimonial.content }}</p>
        </div>
      </div>
    </div>
    
    <div class="section-footer">
     <app-apply-button></app-apply-button>
    </div>
  </div>
</section> 